
import { Component, Vue } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import DevScrumRepository from '@/services/Dev-scrum';
import { AuditInterface, AuditTableInterface } from '@/services/Dev-scrum/interfaces';
import ProfileRepository from '@/services/Users-profile';
import * as XLSX from 'xlsx';
import DeleteAuditDialog from "@/components/dialogs/dev-scrums/DeleteAuditDialog.vue";

@Component({
  components: { DeleteAuditDialog, ViewAllAudits },
  inject: [
    'devScrumRepository',
    'profileRepository',
  ],
})
export default class ViewAllAudits extends Vue {
  private loading: boolean = true;
  private readonly devScrumRepository: DevScrumRepository;
  private profileRepository: ProfileRepository;
  private audits: AuditTableInterface[] = [];
  private deleteAuditDialog: string = '';
  private deleteAuditForDialog: AuditInterface | undefined = undefined;

  private headers: DataTableHeader[] = [
    { text: 'Date', value: 'date' },
    { text: 'Shift', value: 'shift' },
    {
      text: 'Component',
      value: 'components',
      sort: (a: string, b: string) => a.localeCompare(b),
    },
    { text: 'Ticket', value: 'ticket', sortable: false },
    { text: 'Time', value: 'time', sortable: false },
    { text: 'Name', value: 'username', sortable: false },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private async created(): Promise<void> {
    const userId = this.$store.getters.id;
    await this.initialize(userId);
  }

  private async initialize(userId: string): Promise<void> {
    const audits = await this.devScrumRepository.getAllAudits()


    this.audits = await Promise.all(audits.map(async (audit: any) => {
      const auditWithName = { ...audit };
      console.log('user ids', audit.userId);

      try {
        const profile = await this.profileRepository.getBaseProfileDataByUserId(audit.userId);
        auditWithName.username = profile.fullName ? profile.fullName : `${profile.firstName} ${profile.lastName}`;
        auditWithName.date = new Date(auditWithName.date)
          .toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });

        return auditWithName;
      } catch (e) {
        console.log('error', e);
      }
    }));

    this.loading = false;
  }

  private createAudit(): void {
    this.$router.push({ name: 'create_audit' });
  }
  private async exportToExcel(): Promise<void> {
    const wb = XLSX.utils.book_new();
    const auditToExcel = await Promise.all(this.audits.map(async (au) => {
      const profile = await this.profileRepository.getBaseProfileDataByUserId(au.userId);
      return {
        date: au.date,
        shift: au.shift,
        components: Array.isArray(au.components) ? au.components.join(', ') : au.components,
        ticket: au.ticket,
        time: au.time,
        name: profile.fullName ? profile.fullName : `${profile.firstName} ${profile.lastName}`,
      };
    }));
    const ws = XLSX.utils.json_to_sheet(auditToExcel, { header: ['date', 'shift', 'components', 'ticket', 'time', 'name'] });
    XLSX.utils.book_append_sheet(wb, ws, 'Audits');
    XLSX.writeFile(wb, 'audits.xlsx');
  }

  private editAudit(audit: AuditInterface): void {
    this.$router.push({ name: 'audit_edit', params: { auditId: String(audit.id) } });
  }

  private deleteAudit(audit: AuditInterface): void {
    this.deleteAuditDialog = 'delete-audit-dialog';
    this.deleteAuditForDialog = audit;
  }

  private onAuditDeleted(deletedAuditId: number): void {
    this.audits = this.audits.filter(audit => audit.id !== deletedAuditId);
    this.deleteAuditForDialog = undefined;
  }

}
